(function () {
  // Under the thumbnail/thumbnail_slider gallery layouts, Dawn hides every non-active
  // slide (display: none) and only ever switches the active one by clicking a thumbnail
  // button, via MediaGallery.setActiveMedia() in media-gallery.js. The main viewer's own
  // prev/next slider-buttons are still rendered, but their only wired behavior (from the
  // generic SliderComponent in global.js) is adjusting scrollLeft on the slide list --
  // which does nothing under this layout, since there's nothing left to scroll to. That's
  // why clicking them appeared to do nothing: they were never connected to advancing the
  // active image in the first place.
  //
  // Fix: reuse Dawn's own, already-working thumbnail click handler by programmatically
  // clicking the next/previous thumbnail's button when a main-viewer arrow is clicked.
  // Scoped to `[id^="GalleryViewer"]` so this can't affect the separate thumbnail-row
  // slider-component's own (legitimate, working) scroll buttons.

  function getThumbnailButtons(gallery) {
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbnails) return [];
    return Array.prototype.slice.call(thumbnails.querySelectorAll('[data-target]'));
  }

  function getActiveIndex(thumbnailButtons) {
    for (var i = 0; i < thumbnailButtons.length; i++) {
      var button = thumbnailButtons[i].querySelector('button');
      if (button && button.getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  function handleClick(event) {
    var button = event.currentTarget;
    var gallery = button.closest('media-gallery');
    if (!gallery) return;

    var thumbnailButtons = getThumbnailButtons(gallery);
    if (thumbnailButtons.length < 2) return;

    var currentIndex = getActiveIndex(thumbnailButtons);
    var direction = button.classList.contains('slider-button--next') ? 1 : -1;
    var nextIndex = (currentIndex + direction + thumbnailButtons.length) % thumbnailButtons.length;

    var targetButton = thumbnailButtons[nextIndex].querySelector('button');
    if (targetButton) targetButton.click();
  }

  function init() {
    document
      .querySelectorAll('media-gallery [id^="GalleryViewer"] > .slider-buttons .slider-button')
      .forEach(function (button) {
        if (button.dataset.galleryArrowInit) return;
        button.dataset.galleryArrowInit = 'true';
        button.addEventListener('click', handleClick);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
